import { COLORS, PRIMARY0 } from '../../config/designSystem/Colors';
import { PropsWithChildren } from 'react';
import { TextInput, TouchableOpacity, View } from 'react-native';




interface TextInputProps extends PropsWithChildren{
    inputRef: React.RefObject<TextInput> | null,
    maxWidth?: number;
}
export const TextInputTouchable = ({children, inputRef, maxWidth} : TextInputProps) => {
  return(
    <TouchableOpacity onPress={() => inputRef?.current?.focus()}>
      <View
        style={[{
          flexDirection: 'row',
          gap: 8,
          paddingVertical: 10,
          paddingHorizontal: 14,
          borderRadius: 8,
          backgroundColor: COLORS.surface.contrast,
          borderColor: COLORS.surface['inverse-primary'],
          borderWidth:1,
          alignItems:'center',
          maxWidth: maxWidth || 300,
          shadowColor: PRIMARY0,
          shadowOffset: {
            width: 0,
            height: 0,
          },
          shadowOpacity: 1,
          shadowRadius: 4,
          elevation: 4,
        }]}
      >
        {children}
      </View>
    </TouchableOpacity>);
};

